import { BuildClass, clamp } from '../../../universal';
import { React, ReactDOM, _ } from '../../lib';
import { ConditionalObject } from './meta-types';
import { stubDiv } from './stubs';
export const Modal = (props) => {
    const mounted = React.useRef(false);
    const element = React.useRef(stubDiv);
    const [__, setEl] = React.useState();
    React.useEffect(() => {
        mounted.current = true;
        const container = document.querySelector('#modal-container');
        if (!container) {
            console.error('No #modal-container defined');
            return _.noop;
        }
        let el = container.querySelector('.available');
        if (el) {
            element.current = el;
            setEl(el);
            return _.noop;
        }
        el = document.createElement('div');
        container.appendChild(el);
        element.current = el;
        setEl(el);
        return () => {
            if (element.current) {
                element.current.className = 'ui5-modal available';
            }
            mounted.current = false;
        };
    }, []);
    React.useEffect(() => {
        if (element.current) {
            element.current.className = BuildClass({
                'ui5-modal': true,
                [props.className ?? '']: true,
            });
        }
    }, [props.className, element.current]);
    if (!element.current) {
        return React.createElement(React.Fragment, null);
    }
    return ReactDOM.createPortal(props.children, element.current);
};
const ModalAnchoredComponent = (props, ref) => {
    const element = React.useRef(stubDiv);
    const alignX = props.alignX ?? 'left';
    const rect = props.mountElement.getBoundingClientRect();
    const width = props.width ?? rect.width;
    const leftMap = {
        left: rect.left,
        right: rect.right - width,
        center: (rect.left + rect.right - width) / 2,
    };
    const left = clamp(leftMap[alignX], 0, window.innerWidth - width);
    const flipThreshold = props.flipHeightThreshold ?? props.maxHeight;
    const height_down = clamp(window.innerHeight - rect.bottom, 0, props.maxHeight);
    const height_up = clamp(rect.top, 0, props.maxHeight);
    const isFlipped = (props.flipByDefault ?? false)
        ? !(height_up < flipThreshold && height_down > height_up)
        : height_down < flipThreshold && height_up > height_down;
    const height = isFlipped ? height_up : height_down;
    const top = isFlipped ? rect.top - height_up - 1 : rect.bottom - 1;
    React.useImperativeHandle(ref, () => ({
        getElement: () => element.current,
    }));
    return (React.createElement(Modal, null,
        React.createElement("div", { ref: element, className: BuildClass({
                'ui5-modal-inner': true,
                [props.className ?? '']: true,
                hidden: props.hidden,
                flipped: isFlipped,
            }), style: {
                left: `${left}px`,
                top: `${top}px`,
                width: `${width}px`,
                maxHeight: `${height}px`,
                minWidth: `${width}px`,
            }, onMouseDown: e => {
                e.stopPropagation();
                e.preventDefault();
            } }, ConditionalObject(!props.hidden, props.children))));
};
export const ModalAnchored = React.forwardRef(ModalAnchoredComponent);
//# sourceMappingURL=modal.js.map